import React from 'react';
import { IonRow, IonCol } from '@ionic/react';

import { ApplicationState } from '../store';

import { useSelector, useDispatch } from 'react-redux';

import { simpleChannelType } from '../store/LocationStore';
import Button from './Button';
import * as BasketStore from '../store/BasketStore';

const MopFooterUpsellPage: React.FC = () => {
    const locationState = useSelector((state: ApplicationState) => state.location);
    const menuItemData = useSelector((state: ApplicationState) => state.menuItemData);
    const dispatch = useDispatch();

    const goToNextPage = () => {
        dispatch(BasketStore.actionCreators.showAllergen(true))
    };

    return (
        <div className="MopFooterInner">
            { menuItemData?.menuItem &&
                <IonRow className="ion-align-items-center">
                    <IonCol size="6" className="FooterStoreWrapper">
                        <span className="CollectFrom">{locationState?.selectedChannel === undefined ? "Store" : locationState.selectedChannel.channelType === simpleChannelType.ClickAndCollect ? "Take away" : "Eat in" }</span><br/>
                        <span className="Location">{locationState?.selectedStore === undefined ? "Select a store" : locationState?.selectedStore.storeName}</span>
                        {locationState?.selectedStore?.takingMopOrders === false ? <span style={{ color: "#ff0" }}> - Order ahead not available</span> : null}
                    </IonCol>
                    <IonCol size="6">
                        <Button
                            onClick={goToNextPage}
                            expand="block"
                            color="light"
                            size="small"
                            rounded
                        >
                            Continue
                        </Button>
                    </IonCol>
                </IonRow>
            }
        </div>
    );
};

export default MopFooterUpsellPage;
